import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { Link } from '@s20/components/common/Link';
import { httpClient } from '@s20/services/httpClient';
import { ApiRoutes, AppNavPaths } from '../../Common';
import { Modal } from '../../common/Modal';
import Chip from '../../common/forms/Chip';
import { TipAlert } from '../../common/TipAlert';

const getJobLink = (dp) => {
    if (!dp.isAccessible) return undefined;
    if (dp.projectId) return `${AppNavPaths.Project}/${dp.projectId}?openJob=${dp.jobId}`;
    return `${AppNavPaths.Job}/${dp.jobId}`;
};

export const getDuplicateJobs = async ({
    duplicateJobRequests,
}) => {
    if (!duplicateJobRequests.length) return [];

    const duplicateJobs = await httpClient.post(
        ApiRoutes.job.getDuplicateJobs(),
        { duplicateJobRequests },
    );

    return duplicateJobs ?? [];
};

export const showDuplicateJobsModal = async (duplicatejobsList) => {
    const jobsByDate = [];

    duplicatejobsList.forEach((dp) => {
        (dp.jobDates || []).forEach((date) => {
            const dateLabel = moment(date).format('MMM D YYYY');
            const alreadyAdded = jobsByDate.some(
                (j) => j.jobId === dp.jobId && j.dateLabel === dateLabel,
            );
            if (!alreadyAdded) {
                jobsByDate.push({ ...dp, dateLabel });
            }
        });
    });

    const groupedByDate = jobsByDate.reduce((groups, dp) => {
        if (!groups[dp.dateLabel]) groups[dp.dateLabel] = [];
        groups[dp.dateLabel].push(dp);
        return groups;
    }, {});

    return await Modal.ask({
        title: 'Duplicate Jobs',
        SaveButtonProps: { label: 'Proceed' },
        body: () => (
            <div className="mb-4">
                <TipAlert
                    tipText="Note"
                    label={(
                        <strong>
                            The below jobs already exist at this location for the selected date(s)
                        </strong>
                    )}
                />
                {Object.entries(groupedByDate).map(([date, jobs]) => (
                    <div
                        key={date}
                        className="mb-2"
                    >
                        <strong className="d-block mb-1">{date}</strong>
                        {jobs.map((dp) => (
                            <Chip
                                key={`${dp.jobId}-${date}`}
                                component={dp.isAccessible ? Link : 'span'}
                                to={getJobLink(dp)}
                                target={dp.isAccessible ? '_blank' : undefined}
                                rel={dp.isAccessible ? 'noopener noreferrer' : undefined}
                                className="mr-2"
                                text={(
                                    <>
                                        {dp.dispatchOfficeName} {' - '} {dp.jobNumber}{' '}
                                        {dp.isAccessible && (
                                            <FontAwesomeIcon
                                                icon={faArrowUpRightFromSquare}
                                                className="ms-3"
                                            />
                                        )}
                                    </>
                                )}
                            />
                        ))}
                    </div>
                ))}
            </div>
        ),
    });
};